// extracted by mini-css-extract-plugin
export var grid = "BlogPost-module--grid--45942";
export var mainContent = "BlogPost-module--mainContent--92e98";
export var root = "BlogPost-module--root--3289c undefined";